import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as l, normalizeClass as d, createElementVNode as r } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconFreshsalesCrm",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  d: "M20 2.067h-8.813a9.62 9.62 0 0 0-4.074 1.266 9.9 9.9 0 0 0-4.993 8.46c0 9.047 9.027 10.067 9.027 10.067S18.6 23.28 21.64 14.2c.143-.444.217-.907.22-1.373l.073-8.947A3.227 3.227 0 0 0 20 2.067Z",
  fill: "#FFA800"
}, null, -1), m = /* @__PURE__ */ r("path", {
  d: "M12.1 10.927a1.947 1.947 0 1 0 0-3.894 1.947 1.947 0 0 0 0 3.894Zm-4.367.733h8.527l-3.393 3.407-.027 1.9h-1.687v-1.914l-3.42-3.393Z",
  fill: "#fff"
}, null, -1), h = [
  _,
  m
];
function f(e, u, s, p, b, a) {
  return l(), i("svg", {
    "aria-label": s.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--freshsales-crm"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Freshsales Crm",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, c);
}
const C = /* @__PURE__ */ n(o, [["render", f]]);
export {
  C as default
};
//# sourceMappingURL=freshsales-crm.js.map
